const TEXT_ELEMENT_TAG = ['BR', 'A', 'B', 'SPAN']
const CONTAINER_ELEMENT_TAG = ['UL', 'OL', 'LI', 'BLOCKQUOTE', 'DIV']


export function traverseArticle (data, is_container = false) {
  const container = initContainer(data, is_container, this) 
  const dom_stack = [...container.childNodes].reverse()
  const content = []
  while (dom_stack.length != 0) {
    let cur = dom_stack.pop()
    if (isContainerElement(cur)) {
      let inner = handleContainerCpt.call(this, cur)
      if (inner instanceof Array) {
        content.push(...inner)
      } else {
        content.push(inner)
      }
    } else if (isImgELement(cur)) {
      let card = this.card_delegate.handleCardDOM(cur)
      if (card.cpt) {
        content.push(card)
      } else {
        content.push(handleBaseCpt.call(this, cur))
      }
    } else if (!hasElementNodeInside(cur)) {
      content.push(handleBaseCpt.call(this, cur))
    } else {
      dom_stack.push(...Array.from(cur.childNodes).reverse())
    }
  }
  return content.filter(Boolean)
}


function handleContainerCpt (node) {
  let temp 
  switch (node.tagName) {
    case 'BLOCKQUOTE': {
      temp = this.base_delegate.handle('blockquote', node)
      temp.data.children = traverseArticle.call(this, node.innerHTML, true)
      break
    }
    case 'LI': {
      temp = this.base_delegate.handle('line', node)
      if (!hasElementNodeInside(node)) {
        temp.data.children = node.innerHTML
      } else {
        temp.data.children = traverseArticle.call(this, node.innerHTML, true)
      }
      break
    }
    case 'UL': {
      temp = this.base_delegate.handle('unorder_list', node)
      temp.data.children = traverseArticle.call(this, node.innerHTML, true)
      break
    }
    case 'OL': {
      temp = this.base_delegate.handle('order_list', node)
      temp.data.children = traverseArticle.call(this, node.innerHTML, true)
      break
    }
    default: {
      temp = traverseArticle.call(this, node.innerHTML, true)
    }
  }
  return temp
}

function handleBaseCpt (node) {
  switch (node.tagName) {
    case 'H1': {
      // console.log('[h1]: ', node);
      return  this.base_delegate.handle('main_title', node)
      break
    }
    case 'H2': {
      // console.log('[h2]: ', node);
      return  this.base_delegate.handle('main_title', node)
      break
    }
    case 'H3': {
      // console.log('[h3]: ', node);
      return  this.base_delegate.handle('sub_title', node)
      break
    }
    case 'H4': {
      // console.log('[h4]: ', node);
      return  this.base_delegate.handle('img_desc', node)
      break
    }
    case 'IMG': {
      // console.log('[img]: ', node);
      return  this.base_delegate.handle('img', node)
      break
    }
    case 'IFRAME': {
      // console.log('[iframe]: ', node);
      return  this.base_delegate.handle('iframe', node)
      break
    }
    case 'P': {
      // console.log('[text]: ', node);
      return  this.base_delegate.handle('text', node)
      break
    }
    case 'ORIGIN-SOURCE': {
      // console.log('[origin-source]: ', node);
      return  this.base_delegate.handle('origin_source', node)
      break
    }
    case 'NEWS-SOURCE': {
      // console.log('[news-source]: ', node);
      return  this.base_delegate.handle('news_source', node)
      break
    }
    default: {
      // console.log('[other]: ', node);
      return  this.base_delegate.handle('text', node)
    }
  }
}


// 初始化container dom
function initContainer (content, is_container, article) {
  if (!is_container) {
    content = prehandleSpecialHtml(content)
  }
  let container = document.createElement('div')
  container.innerHTML = content
  if (!is_container) {
    article.preproccess_delegate.handleContent(container)
    recoverSpecialHtml(container)
  }
  return container
}
// 提前处理特殊标签
function prehandleSpecialHtml (content) {
  content = content.replace(/(<figure.*?>|<\/figure>)/ig, '');
  content = content.replace(/(<figcaption.*?>|<\/figcaption>)/ig, '');
  content = content.replace(/&lt;/gi, '_-_&lt;_-_')
  content = content.replace(/&gt;/gi, '_-_&gt;_-_')
  content = content.replace(/data-link-type=\"text\"/g, 'data-link-type=\"text\" class="a-link"')
  content = content.replace(/src="\/\//g, `src="https:\/\/`)
  return content
}
//恢复特殊标签
function recoverSpecialHtml (dom) {
  if (!dom.childNodes || dom.childNodes.length == 0) {
    if (dom.nodeType == 3) {
      dom.data = dom.data.replace(/_-_<_-_/gi, '<')
      dom.data = dom.data.replace(/_-_>_-_/gi, '>')
    }
    return
  }
  Array.from(dom.childNodes).forEach(child => {
    recoverSpecialHtml(child)
  });
}

function isImgELement (node) {
  if (node.nodeType != 1) return false
  return node.tagName == 'IMG'
}

function isContainerElement (node) {
  if (node.nodeType != 1) return false
  return CONTAINER_ELEMENT_TAG.includes(node.tagName)
}

function hasElementNodeInside (node) {
  if (node.nodeType != 1) return false
  
  return Array.from(node.childNodes).find(_=>_.nodeType == 1 && !TEXT_ELEMENT_TAG.includes(_.tagName))
}